import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Optionally add/remove class on body for side menu open
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('enable-vertical-menu');
    } else {
      document.body.classList.remove('enable-vertical-menu');
    }
    // Clean up on unmount
    return () => {
      document.body.classList.remove('enable-vertical-menu');
    };
  }, [sidebarOpen]);

  const handleMenuToggle = () => setSidebarOpen(open => !open);
  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <div className="layout-wrapper">
      <header id="page-topbar">
        <Nav onMenuToggle={handleMenuToggle} />
      </header>

      <div className={`vertical-menu${sidebarOpen ? ' open' : ''}`}>
        <Sidebar />
      </div>

      {/* Overlay for sidebar on mobile */}
      <div
        className={`menu-overlay${sidebarOpen ? ' show' : ''}`}
        onClick={handleOverlayClick}
        style={{ display: sidebarOpen ? 'block' : 'none' }}
      />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>

        <footer className="main-footer">
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default AppLayout;